import { useState } from "react";
import { Link as RouterLink, useParams } from "react-router-dom";
import { Close } from "@mui/icons-material";
import {
  Box,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Stack,
  Typography as T,
} from "@mui/material";
import useIsMasterDataset from "datasets/hooks/useIsMasterDataset";
import IngestForm from "datasets/pages/tables/components/IngestForm";
import SnowflakeForm from "datasets/pages/tables/components/SnowflakeForm";
import { IngestProvider } from "datasets/pages/tables/contexts/ingest";
import { TableAccessLevel } from "datasets/types/enums/access-level";

const AddTable = () => {
  const isMasterDataset = useIsMasterDataset();
  const { datasetId } = useParams();
  const [dataLocation, setDataLocation] = useState("cloud");

  return (
    <Stack gap={2}>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <T variant="h6" component="h3" fontWeight={600}>
          Add Table
        </T>
        <IconButton
          size="small"
          aria-label="Back to dataset tables"
          component={RouterLink}
          to={`/data-browser/datasets/${datasetId}/tables`}
        >
          <Close />
        </IconButton>
      </Box>
      <Stack gap={1}>
        {!isMasterDataset && (
          <>
            <T variant="body2" fontWeight={500}>
              Where is your data located?
            </T>
            <RadioGroup
              row
              sx={{ gap: 1 }}
              value={dataLocation}
              onChange={(e) => setDataLocation(e.currentTarget.value)}
            >
              <FormControlLabel value="cloud" control={<Radio size="small" />} label="From File" />
              <FormControlLabel
                value="database"
                control={<Radio size="small" />}
                label="Database"
              />
            </RadioGroup>
          </>
        )}
      </Stack>
      {dataLocation === "cloud" && (
        <IngestProvider>
          <IngestForm />
        </IngestProvider>
      )}
      {dataLocation === "database" && <SnowflakeForm accessLevel={TableAccessLevel.WRITE} />}
    </Stack>
  );
};

export default AddTable;
